var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-col',{attrs:{"vs-type":"flex","vs-justify":"center","vs-align":"center","vs-w":_vm.width,"vs-sm":"4","vs-xs":"12"}},[_c('vs-card',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }